import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './components/button/button.component';
import { ButtonModule as PrimeButtonModule } from 'primeng/button';
import { IconButtonComponent } from './components/icon-button/icon-button.component';
import { ActionIconButtonComponent } from './components/action-icon-button/action-icon-button.component';
import { ButtonCardComponent } from './components/button-card/button-card.component';
import { ButtonMultiSelectComponent } from './components/button-multi-select/button-multi-select.component';
import { MicrosoftButtonComponent } from './components/microsoft-button/microsoft-button.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ButtonComponent,
    IconButtonComponent,
    ActionIconButtonComponent,
    ButtonCardComponent,
    ButtonMultiSelectComponent,
  ],
  imports: [
    CommonModule,
    PrimeButtonModule,
    FormsModule,
    MultiSelectModule,
    MicrosoftButtonComponent,
  ],
  exports: [
    ButtonComponent,
    IconButtonComponent,
    ActionIconButtonComponent,
    ButtonCardComponent,
    ButtonMultiSelectComponent,
    MicrosoftButtonComponent,
    PrimeButtonModule,
  ],
})
export class ButtonModule {}
